// extracted by mini-css-extract-plugin
export default {"accountInfo__img":"AccountInfo_accountInfo__img__Vf9gU","accountInfo__name":"AccountInfo_accountInfo__name__ideXY","accountInfo":"AccountInfo_accountInfo__x3WXY"};